<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
        class="flex items-center justify-center"
        :style="sizingStyle"
        aria-hidden="true"
        role="presentation"
        v-html="svgContent"
    />
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        width: {
            type: [String, Number],
            default: '24px',
        },
        height: {
            type: [String, Number],
            default: '24px',
        },
        fill: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            svgContent: '',
        };
    },
    computed: {
        sizingStyle() {
            return {
                height: `${this.height || 24}px`,
                width: `${this.width || 24}px`,
            };
        },
    },
    watch: {
        icon: {
            handler(newIcon, oldIcon) {
                if (newIcon && newIcon !== oldIcon) {
                    this.loadIcon();
                }
            },
            immediate: false,
        },
        svgContent: {
            handler(newContent) {
                if (newContent) {
                    this.$nextTick(() => {
                        this.applyStyling();
                    });
                }
            },
            immediate: true,
        },
    },
    async created() {
        await this.loadIcon();
    },
    mounted() {
        // Si el contenido ya está cargado, aplicar estilos inmediatamente
        if (this.svgContent) {
            this.$nextTick(() => {
                this.applyStyling();
            });
        }
    },
    methods: {
        async loadIcon() {
            if (!this.icon) return;

            try {
                const module = await import(`../../images/icons/${this.icon}.svg?raw`);
                this.svgContent = module.default;
            } catch (error) {
                console.error('Error loading SVG:', this.icon, error);
            }
        },
        applyStyling() {
            if (!this.$el || !this.$el.firstChild) {
                return;
            }

            this.$el.style.pointerEvents = 'none';

            const svgElement = this.$el.firstChild;
            if (svgElement) {
                svgElement.classList.add(this.$style.svg);

                if (this.iconClass) {
                    svgElement.classList.add(this.iconClass);
                }

                svgElement.removeAttribute('width');
                svgElement.style.width = this.width || '24px';

                svgElement.removeAttribute('height');
                svgElement.style.height = this.height || '24px';

                if (svgElement.getAttribute('fill') !== 'none') {
                    svgElement.style.fill = 'currentColor';
                }

                // Apply custom fill if specified directly in the component's icon
                if (this.fill) {
                    svgElement.removeAttribute('fill');
                    svgElement.style.fill = this.fill;
                }

                svgElement.setAttribute('aria-hidden', 'true');
                svgElement.setAttribute('focusable', 'false');
            }
        },
    },
};
</script>

<style module>
/*
* Not converted to Tailwind as these styles are applied when the SVG is rendered directly as an <svg> tag
* https://vue-loader.vuejs.org/guide/css-modules.html
*/
svg {
    vertical-align: middle;
    width: 24px;
    height: 24px;
}
</style>
